import { Box, Modal, Typography, IconButton } from "@mui/material";
import union_img from "../../assets/baseVersion/Union.svg";
import CancelIcon from "@mui/icons-material/Cancel";

const LetsTalk = ({ isModalOpen, setIsModalOpen }: any) => {
  const style = {
    position: "absolute" as const,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 3,
    textAlign: "center",
  };

  return (
    <Modal
      open={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
           <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton onClick={() => setIsModalOpen(false)}>
            <CancelIcon sx={{ color: "#8f8f8f" }} />
          </IconButton>
        </Box>

      <Box sx={style}>
        {/* Close Icon */}
     
        {/* Crown Icon */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <img src={union_img} alt="crown" style={{ width: "70px" }} />
        </Box>

        {/* Title */}
        <Typography
          variant="h6"
          sx={{ fontWeight: "bold", mb: 1 }}
        >
          Upgrade Subscription Request!
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="body2"
          sx={{ fontSize: "15px", color: "#666666" }}
        >
          We've received your request on the subscription upgrade, our team
          will reach out to you on the further information.
        </Typography>
      </Box>
    </Modal>
  );
};

export default LetsTalk;
